















































































































































import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
import { IEviMember } from "@/model/evimember";
import { defaultEviMemberData } from "@/api/evimember";
import { getUserInfo, updateUserInfo, updatePassword } from "@/api/users";

import { isValidEmail } from "@/utils/validate";
import { UserModule } from "@/store/modules/user";

@Component({
  name: "currentMember"
})
export default class extends Vue {
  private eviMemberData = defaultEviMemberData;

  private dialogImageUrl = "";
  private dialogVisible = false;
  private dialogUpdatePassword = false;
  private fileListAvatar: any[] = [];

  private uploadUrl = "/api/ImageUpload/Upload";

  private imageAvatarCompany = {
    ImageType: 4
  };

  private passwordModel = {
    oldPassword: "",
    newPassword: "",
    newPasswordAgain: ""
  };

  private openUpdatePassword() {
    this.passwordModel.oldPassword = "";
    this.passwordModel.newPassword = "";
    this.passwordModel.newPasswordAgain = "";
    this.dialogUpdatePassword = true;
  }

  private async handleUpdate() {
    (this.$refs.memberForm as Form).validate(async valid => {
      if (valid) {
        console.log(this.eviMemberData);
        await updateUserInfo(this.eviMemberData).then(() => {
          this.$message({
            message: "修改成功",
            type: "success",
            duration: 2000
          });

          UserModule.SetAvatar(this.eviMemberData.avatar);
        });
      }
    });
  }

  private handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  private handleUpdatePassword() {
    (this.$refs.updatePasswordForm as Form).validate(async valid => {
      if (valid) {
        await updatePassword(this.passwordModel).then(() => {
          this.$message({
            message: "修改成功",
            type: "success",
            duration: 2000
          });

          UserModule.LogOut();
          location.reload();
        });
      }
    });
  }

  // 检验邮箱
  private checkEmail = (rule: any, value: string, callback: Function) => {
    if (value === "" || value === undefined || value === null) {
      callback();
    } else if (!isValidEmail(value)) {
      // 返回错误提示
      callback(new Error("请输入正确格式的邮箱"));
    }

    callback();
  };

  private validatePass = (rule: any, value: string, callback: Function) => {
    if (value === "") {
      callback(new Error("请输入新密码"));
    } else if (value === this.passwordModel.oldPassword) {
      callback(new Error("新密码与旧密码相同!"));
    } else {
      callback();
    }
  };

  private validatePassAgain = (
    rule: any,
    value: string,
    callback: Function
  ) => {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.passwordModel.newPassword) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  };

  private memberRules = {
    email: [
      {
        validator: this.checkEmail,
        message: "邮箱格式不正确，请重新输入",
        trigger: "blur"
      }
    ]
  };

  private updatePasswordRules = {
    oldPassword: [
      { required: true, message: "请输入旧密码", trigger: "blur" }
      // {
      //   pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
      //   message:
      //     "密码为数字，小写字母，大写字母，特殊符号 至少包含三种，长度为 8 - 30位"
      // }
    ],
    newPassword: [
      { required: true, validator: this.validatePass, trigger: "blur" },
      {
        pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
        message:
          "密码为数字，小写字母，大写字母，特殊符号 至少包含三种，长度为 6 - 30位"
      }
    ],
    newPasswordAgain: [
      { required: true, validator: this.validatePassAgain, trigger: "blur" }
    ]
  };

  created() {
    this.getUser();
  }

  private async getUser() {
    const { data } = await getUserInfo();
    this.eviMemberData = data;

    if (data.avatar !== "") {
      const obj = {
        url: data.avatar
      };
      this.fileListAvatar.push(obj);
    }
  }

  private limitCountFunc() {
    this.$message({
      message: "请先删除再添加",
      type: "info",
      duration: 2000
    });
  }

  private handleRemove(file: any, fileList: any) {
    console.log(file);
    console.log(fileList);
    if (
      file.url === this.eviMemberData.avatar ||
      file.response.data.fileName === this.eviMemberData.avatar
    ) {
      this.eviMemberData.avatar = "";
    }
  }

  // private handleUploadSuccess(response: any, file: any, fileList: any) {
  //   // console.log(response);
  //   // console.log(file);
  //   // console.log(fileList);

  //   if (response.status !== 1) {
  //     this.$message.error(response.msg);
  //     return;
  //   }

  //   this.eviMemberData.avatar = response.data.fileName;
  // }

  private handleUploadSuccess(response: any, file: any, fileList: any) {
    if (response.status !== 1) {
      // 删除上传列表中，失败的文件
      let index = 0;
      for (var i = 0; i < fileList.length; i++) {
        if (fileList[i] === file) {
          index = i;
          break;
        }
      }

      // 移出当前文件对象
      fileList.splice(index, 1);
      this.$message.error(response.msg);
      return;
    }

    this.eviMemberData.avatar = response.data.fileName;
  }

  private handleUploadError(response: any, file: any, fileList: any) {
    console.log(response);
    console.log(file);
    console.log(fileList);
    this.$message.error(JSON.parse(response.message).msg);
  }

  private initData() {
    this.eviMemberData.id = "";
    this.eviMemberData.group_Id = 0;
    this.eviMemberData.memberName = "";
    this.eviMemberData.nickName = "";
    this.eviMemberData.password = "";
    this.eviMemberData.salt = "";
    this.eviMemberData.email = "";
    this.eviMemberData.mobile = "";
    this.eviMemberData.avatar = "";
    this.eviMemberData.gender = 0;
    this.eviMemberData.money = 0;
    this.eviMemberData.score = 0;
    this.eviMemberData.prevTime = 0;
    this.eviMemberData.loginTime = 0;
    this.eviMemberData.loginIP = "";
    this.eviMemberData.loginFailure = 0;
    this.eviMemberData.joinIP = "";
    this.eviMemberData.joinTime = 0;
    this.eviMemberData.createTime = 0;
    this.eviMemberData.updateTime = 0;
    this.eviMemberData.token = "";
    this.eviMemberData.status = "";
    this.eviMemberData.verification = "";
  }

  private setData(data: IEviMember) {
    this.eviMemberData.id = data.id;
    this.eviMemberData.group_Id = data.group_Id;
    this.eviMemberData.memberName = data.memberName;
    this.eviMemberData.nickName = data.nickName;
    this.eviMemberData.password = data.password;
    this.eviMemberData.salt = data.salt;
    this.eviMemberData.email = data.email;
    this.eviMemberData.mobile = data.mobile;
    this.eviMemberData.avatar = data.avatar;
    this.eviMemberData.gender = data.gender;
    this.eviMemberData.money = data.money;
    this.eviMemberData.score = data.score;
    this.eviMemberData.prevTime = data.prevTime;
    this.eviMemberData.loginTime = data.loginTime;
    this.eviMemberData.loginIP = data.loginIP;
    this.eviMemberData.loginFailure = data.loginFailure;
    this.eviMemberData.joinIP = data.joinIP;
    this.eviMemberData.joinTime = data.joinTime;
    this.eviMemberData.createTime = data.createTime;
    this.eviMemberData.updateTime = data.updateTime;
    this.eviMemberData.token = data.token;
    this.eviMemberData.status = data.status;
    this.eviMemberData.verification = data.verification;
  }
}
